import styles from './ProductPurchase.module.css';

type ProductPurchaseLimitMessageProps = {
  testid: string;
  message: string;
};

export default function ProductPurchaseLimitMessage({ testid, message }: ProductPurchaseLimitMessageProps) {
  return (
    <div className="my-4" data-testid={testid}>
      <div className={styles.purchaseLimitContainer}>
        <div>
          <span className={styles.purchaseLimitNote}>Please note:</span>
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
}
